import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsIcon, BdsInput } from 'blip-ds/dist/blip-ds-react';

export const SearchInput = styled(BdsInput)`
  width: 18.75rem;
`;

export const MoreOptionsButton = styled(BdsIcon)`
  cursor: pointer;
`;

export const CatalogUpdatedBy = styled.div`
  bds-typo {
    color: ${colors.ContentGhost};
  }
`;
